exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dg-color-sample .dg-sample{width:3.75rem;height:3.75rem;display:block;border-radius:50%;-webkit-box-shadow:0 1px 9px 0 rgba(0,0,0,.13);box-shadow:0 1px 9px 0 rgba(0,0,0,.13);margin-bottom:.5rem}.dg-color-sample .dg-sample-desc{display:block}.dg-color-sample .dg-sample-desc .dg-sample-label{margin-bottom:.25rem;font-weight:700;font-size:.875rem}.dg-color-sample .dg-sample-desc .dg-sample-info{margin-bottom:.25rem;font-size:.8rem;text-transform:uppercase}.dg-color-sample .dg-sample-desc .dg-sample-info.code{text-transform:none;background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78ef83a2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/Colors.vue
// module id = 50d7
// module chunks = 1